// @flow

/**
 * Opens the desktop app.
 *
 * @param {Object} state - Object containing current redux state.
 * @returns {Promise<boolean>} - Resolves with true if the attempt to open the desktop app was successful and resolves
 * with false otherwise.
 */
// eslint-disable-next-line no-unused-vars
export function _openDesktopApp(state) {
  return Promise.resolve(false);
}
